import { useContext } from 'react';
import styles from './tables.module.css';
import { InboundContext } from '../../context/InboundContext';
import Ftux from '../common/Ftux/Ftux';
import { formatCurrency } from '../../utils/global';

type PaymentTableProps = {
  tableBody: {
    name: string;
    payment_date: string;
    amount: string;
  }[];
  totalAmountPaid: number;
};

export default function ContentSubmissionPaymentsTable({ tableBody, totalAmountPaid }: PaymentTableProps) {
  const { defaultCurrency } = useContext(InboundContext);
  return (
    <>
      <div className={styles.totalAmountPaidRow}>
        <div className={styles.totalAmountPaidTitle}>Completed Payments</div>
        <div>
          Total Amount Paid:{' '}
          <span className={styles.totalAmountPaid}>{formatCurrency(Number(totalAmountPaid), defaultCurrency)}</span>
        </div>
      </div>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Submission Title</th>
            <th>Date of Payment</th>
            <th>Total Amount</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {tableBody && tableBody?.length > 0 ? (
            tableBody.map((row, index) => {
              return (
                <tr key={index}>
                  <td>{row.name}</td>
                  <td>{row.payment_date}</td>
                  <td>{formatCurrency(Number(row.amount), defaultCurrency)}</td>
                  <td>
                    <div className={styles.paidStatus}>Paid</div>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={4}>
                <div className={styles.ftuxContainer}>
                  <Ftux
                    emoji="💸"
                    title="No Payments Completed Yet"
                    text="Once payments are made by the brand, they’ll reflect here."
                    bgColor="var(--background-highlight)"
                  />
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
}
